module.exports = __webpack_public_path__ + "static/media/password.f27e4e34.svg";